export const dictionaries = state => state.dictionaries.items

export const categoryNameById = state => id => {
    let category = _.find(dictionaries(state), { id })

    return category ? category.name : ''
}

export const categoryById = state => id => {
    return _.find(dictionaries(state), { id })
}

export const dictionariesLoaded = state => state.services.items.length > 0 && state.users.items.length

export const dictionaryEntriesByType = state => type => _.filter(state.dictionaries.items, { dictionary: type })

export const dictionaryEntryNameByTypeAndId = state => (type, id) => {
    const item = _.find(dictionaryEntriesByType(state)(type), (item) => item.id == id)

    return item ? item.name : null
}

export const states = () => {
    return [
        { id: "AK", name: "AK" },
        { id: "AL", name: "AL" },
        { id: "AR", name: "AR" },
        { id: "AZ", name: "AZ" },
        { id: "CA", name: "CA" },
        { id: "CO", name: "CO" },
        { id: "CT", name: "CT" },
        { id: "DC", name: "DC" },
        { id: "DE", name: "DE" },
        { id: "FL", name: "FL" },
        { id: "GA", name: "GA" },
        { id: "HI", name: "HI" },
        { id: "IA", name: "IA" },
        { id: "ID", name: "ID" },
        { id: "IL", name: "IL" },
        { id: "IN", name: "IN" },
        { id: "KS", name: "KS" },
        { id: "KY", name: "KY" },
        { id: "LA", name: "LA" },
        { id: "MA", name: "MA" },
        { id: "MD", name: "MD" },
        { id: "ME", name: "ME" },
        { id: "MI", name: "MI" },
        { id: "MN", name: "MN" },
        { id: "MO", name: "MO" },
        { id: "MS", name: "MS" },
        { id: "MT", name: "MT" },
        { id: "NC", name: "NC" },
        { id: "ND", name: "ND" },
        { id: "NE", name: "NE" },
        { id: "NH", name: "NH" },
        { id: "NJ", name: "NJ" },
        { id: "NM", name: "NM" },
        { id: "NV", name: "NV" },
        { id: "NY", name: "NY" },
        { id: "OH", name: "OH" },
        { id: "OK", name: "OK" },
        { id: "OR", name: "OR" },
        { id: "PA", name: "PA" },
        { id: "RI", name: "RI" },
        { id: "SC", name: "SC" },
        { id: "SD", name: "SD" },
        { id: "TN", name: "TN" },
        { id: "TX", name: "TX" },
        { id: "UT", name: "UT" },
        { id: "VA", name: "VA" },
        { id: "VT", name: "VT" },
        { id: "WA", name: "WA" },
        { id: "WI", name: "WI" },
        { id: "WV", name: "WV" },
        { id: "WY", name: "WY" },
    ]
}

export const contactLicenses = () => ({
    PE: { value: '', exp_date: null },
    SIA: { value: '', exp_date: null },
    FSC: { value: '', exp_date: null },
    SH: { value: '', exp_date: null },
    SOC: { value: '', exp_date: null },
    RA: { value: '', exp_date: null },
    MP: { value: '', exp_date: null },
    GC: { value: '', exp_date: null },
    SSM: { value: '', exp_date: null }
})

export const projectTypes = () => [
    { id: 1, name: 'Residential' },
    { id: 2, name: 'Commercial' },
    { id: 3, name: 'Manufacturing' },
    { id: 4, name: 'Government' },
    { id: 5, name: 'School' },
    { id: 6, name: 'Non-Profit' }
]

export const projectTypeNameById = () => id => {
    let projectType = _.find(projectTypes(), { id: parseInt(id) })
    return projectType ? projectType.name : 'Not Specified'
}

export const projectServiceStatuses = () => [
    { id: 'approved', name: 'approved' },
    { id: 'dropped', name: 'dropped' },
    { id: 'billed', name: 'billed' },
    { id: 'paid', name: 'paid' },
    { id: 'not_billable', name: 'not billable' },
    { id: 'on_hold', name: 'on hold' },
]

export const projectServiceStatusNameById = () => id => {
    let item = _.find(projectServiceStatuses(), { id: id })
    return item ? item.name : ''
}

export const taskTypes = () => [
    { 'id': 1, 'name': 'My Open Tasks' },
    { 'id': 2, 'name': 'My Tasks Not Updated Within The Last 5 Days' },
    { 'id': 3, 'name': 'My Today Tasks' },
    { 'id': 4, 'name': 'My Tomorrow Tasks' },
    { 'id': 5, 'name': 'My Overdue Tasks' },
    { 'id': 6, 'name': 'All Today Tasks' },
    { 'id': 7, 'name': 'All Tomorrow Tasks' },
    { 'id': 8, 'name': 'All Overdue Tasks' }
]

export const boroughs = () => [
    { 'id': 1, 'name': 'Manhattan' },
    { 'id': 2, 'name': 'Bronx' },
    { 'id': 3, 'name': 'Brooklyn' },
    { 'id': 4, 'name': 'Queens' },
    { 'id': 5, 'name': 'Staten Island' },
    { 'id': 6, 'name': 'Non NYC' },
]

// Project Relations

export const violationTypes = () => [
    { id: 1, name: 'ECB' },
    { id: 2, name: 'DOB' },
    { id: 3, name: 'DEP' },
    { id: 4, name: 'FONY' },
    { id: 5, name: 'DOT' },
]

export const violationTypeNameById = () => (id) => {
    let item = _.find(violationTypes(), { id: parseInt(id) })
    return item ? item.name : ''
}

export const trackingTypes = () => [
    { id: 1, name: 'IBM' },
    { id: 2, name: 'DOT' },
]

export const trackingTypeNameById = () => (id) => {
    let item = _.find(trackingTypes(), { id: parseInt(id) })
    return item ? item.name : ''
}


export const occupancyCertificateTypes = () => [
    { id: 1, name: 'TCO' },
    { id: 2, name: 'C of O' },
]

export const occupancyCertificateTypeNameById = () => (id) => {
    let item = _.find(occupancyCertificateTypes(), { id: parseInt(id) })
    return item ? item.name : ''
}

export const boroughNameById = () => (id) => {
    let borough = _.find(boroughs(), { id: parseInt(id) })
    return borough ? borough.name : ''
}

export const applicationTypes = () => [
    { id: 'after-hours-permit', name: 'After Hours Permit' },
    { id: 'determination', name: 'Determination' },
    { id: 'dot-permit', name: 'Dot Permit' },
    { id: 'filing', name: 'Filing' },
    { id: 'inspection', name: 'Inspection' },
    { id: 'misc-service', name: 'Misc Service' },
    { id: 'occupancy-certificate', name: 'Occupancy Certificate' },
    { id: 'permit', name: 'Permit' },
    { id: 'tracking', name: 'Tracking' },
    { id: 'violation', name: 'Violation' }
]

export const applicationTypeNameById = () => (id) => {
    let item = _.find(applicationTypes(), { id })
    return item ? item.name : ''
}

export const years = () => {
    let minYear = 2005,
        currentYear = (new Date).getFullYear(),
        years = []

    while (minYear <= currentYear) {
        years.push(minYear)
        minYear++
    }

    return years
}

export const monthNameByNumber = (a) => (number) => {
    let month = _.find(months(), { id: _.padStart(number, 2, '0') })
    return month ? month.name : ''
}

export const months = () => {
    return [
        { id: '01', name: 'January' },
        { id: '02', name: 'February' },
        { id: '03', name: 'March' },
        { id: '04', name: 'April' },
        { id: '05', name: 'May' },
        { id: '06', name: 'June' },
        { id: '07', name: 'July' },
        { id: '08', name: 'August' },
        { id: '09', name: 'September' },
        { id: '10', name: 'October' },
        { id: '11', name: 'November' },
        { id: '12', name: 'December' }
    ]
}


// ___________________________________________________

let statuses = [
    { id: 1, name: "Awaiting Signature" },
    { id: 2, name: "In Progress" },
    { id: 3, name: "Dropped" },
    { id: 4, name: "COMPLETED" },
    { id: 5, name: "Awaiting Info" },
    { id: 6, name: "Approved" },
    { id: 7, name: "Declined" },
    { id: 8, name: "Awaiting forms/plans" },
    { id: 9, name: "SIGNED-OFF" },
    { id: 10, name: "Permitted" },
    { id: 11, name: "Assigned to Examiner" },
    { id: 12, name: "On Hold" },
    { id: 13, name: "Under Review" },
    { id: 14, name: "Approved w/ Conditions" },
    { id: 16, name: "Permitted - Ongoing Services" },
    { id: 17, name: "Permitted - Under Construction" },
    { id: 18, name: "Approved - In Progress" },
    { id: 19, name: "Approved - Completed" },
    { id: 20, name: "Issued" },
    { id: 21, name: "Open" },
    { id: 22, name: "Dismissed" },
    { id: 23, name: "Decision Reserved" },
    { id: 24, name: "Resolved - Payment Due" },
    { id: 25, name: "Submitted" },
    { id: 28, name: "Performed" },
    { id: 29, name: "Not Performed" },
    { id: 30, name: "Performed Open Issues" },
    { id: 31, name: "Uninvoiced" },
    { id: 32, name: "To be invoiced" },
    { id: 33, name: "Invoiced" },
    { id: 36, name: "Closed" },
    { id: 37, name: "PRE-FILED" },
    { id: 38, name: "A/P UNPAID" },
    { id: 39, name: "A/P TO D.E.A.R" },
    { id: 40, name: "A/P ENTIRE" },
    { id: 41, name: "AP-NPE" },
    { id: 42, name: "ASSIGNED TO P/E" },
    { id: 43, name: "PAA FEE DUE" },
    { id: 44, name: "P/E IN PROCESS" },
    { id: 45, name: "SIGNOFF" },
    { id: 46, name: "P/E DISAPPROVED" },
    { id: 47, name: "P/E PARTIAL APPROVED " },
    { id: 48, name: "P/E PAA $ PENDING" },
    { id: 49, name: "P/E PAA $ RESOLVED" },
    { id: 50, name: "APPROVED" },
    { id: 51, name: "PERMIT - PARTIAL" },
    { id: 52, name: "PERMIT - ENTIRE" },
    { id: 53, name: "SUSPENDED " },
    { id: 54, name: "Standard" },
    { id: 55, name: "Professional Certification" },
    { id: 56, name: "Pro Cert of Objections" },
    { id: 57, name: "In Process" },
    { id: 58, name: "To be signed off" },

    { id: 59, name: 'Assigned to P/E' },
    { id: 60, name: 'PAA FEE DUE' },
    { id: 61, name: 'P/E PAA $ pending' },
    { id: 62, name: 'A/P entire' },
    { id: 63, name: 'P/E disapproved' },
    { id: 64, name: 'Approved' },
    { id: 65, name: 'Permit-partial' },
    { id: 66, name: 'Permit-entire' },
    { id: 67, name: 'Submitted for sign-off' },
    { id: 68, name: 'Signed-off' },
    { id: 69, name: 'Completed' },
    { id: 70, name: 'Pre-filed' },
    { id: 71, name: 'Paid' },
]

export const statusNameById = () => id => {
    let status = _.find(statuses, { id: parseInt(id) })
    return status ? status.name : 'Not Specified'
}

let statusesByIds = (ids) => {
    return _.filter(statuses, status => {
        return ids.includes(status.id)
    })
}

let statusById = (id) => {
    return _.filter(statuses, status => status.id == id)[0]
}

export const projectStatuses = () => statusesByIds([21, 36, 12])
export const proposalStatuses = () => statusesByIds([1, 3, 6, 7, 12])
export const taskStatuses = () => statusesByIds([2, 4, 12])
export const applicationStatuses = () => statusesByIds([13, 58])
export const taskByLocationDefaultStatuses = () => statusesByIds([2, 12])

export const changeOrderStatuses = () => statusesByIds([21, 36, 58])
// export const filingStatuses = () => statusesByIds([2, 3, 4, 21])
export const filingStatuses = () => statusesByIds([59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70])
export const filingFilingStatuses = () => statusesByIds([54, 55, 56])
export const inspectionsStatuses = () => statusesByIds([28, 29, 30])
export const occupancyCertificateStatuses = () => statusesByIds([1])
export const violationStatuses = () => statusesByIds([21, 22, 23, 24])
export const determinationStatuses = () => statusesByIds([2, 6, 7, 13, 14])
export const trackingStatuses = () => statusesByIds([2, 7, 13, 20])
export const miscServicesStatuses = () => statusesByIds([2, 4, 6, 7, 25])
export const dotPermitStatuses = () => statusesByIds([2, 7, 13, 20])
export const permitStatuses = () => statusesByIds([1, 10, 57])
export const afterHoursPermitStatuses = () => statusesByIds([1, 2, 7, 10])
export const defaultProposalStatus = () => statusById(1)

export const filingApplicationTypes = () => [
    { id: 55, name: "Alt I" },
    { id: 56, name: "AltII" },
    { id: 57, name: "Alt II D14" },
    { id: 58, name: "ALTII Non D14" },
    { id: 59, name: "ALT III" },
    { id: 60, name: "Demo" },
    { id: 62, name: "NB" },
    { id: 63, name: "PA" },
]

export const filingApplicationTypeNameById = () => id => {
    let item = _.find(filingApplicationTypes(), { id: parseInt(id) })
    return item ? item.name : ''
}

// todo generate it instead
export const timelogTimeOptions = () => {
    return [
        { value: 0.25, text: '00 hours 15 minutes' },
        { value: 0.50, text: '00 hours 30 minutes' },
        { value: 0.75, text: '00 hours 45 minutes' },
        { value: 1, text: '1 hour 00 minutes' },
        { value: 1.25, text: '1 hour 15 minutes' },
        { value: 1.50, text: '1 hour 30 minutes' },
        { value: 1.75, text: '1 hour 45 minutes' },
        { value: 2, text: '2 hours 00 minutes' },
        { value: 2.25, text: '2 hours 15 minutes' },
        { value: 2.50, text: '2 hours 30 minutes' },
        { value: 2.75, text: '2 hours 45 minutes' },
        { value: 3, text: '3 hours 00 minutes' },
        { value: 3.25, text: '3 hours 15 minutes' },
        { value: 3.50, text: '3 hours 30 minutes' },
        { value: 3.75, text: '3 hours 45 minutes' },
        { value: 4, text: '4 hours 00 minutes' },
        { value: 4.25, text: '4 hours 15 minutes' },
        { value: 4.50, text: '4 hours 30 minutes' },
        { value: 4.75, text: '4 hours 45 minutes' },
        { value: 5, text: '5 hours 00 minutes' },
        { value: 5.25, text: '5 hours 15 minutes' },
        { value: 5.50, text: '5 hours 30 minutes' },
        { value: 5.75, text: '5 hours 45 minutes' },
        { value: 6, text: '6 hours 00 minutes' },
        { value: 6.25, text: '6 hours 15 minutes' },
        { value: 6.50, text: '6 hours 30 minutes' },
        { value: 6.75, text: '6 hours 45 minutes' },
        { value: 7, text: '7 hours 00 minutes' },
        { value: 7.25, text: '7 hours 15 minutes' },
        { value: 7.50, text: '7 hours 30 minutes' },
        { value: 7.75, text: '7 hours 45 minutes' },
        { value: 8, text: '8 hours 00 minutes' },
        { value: 8.25, text: '8 hours 15 minutes' },
        { value: 8.50, text: '8 hours 30 minutes' },
        { value: 8.75, text: '8 hours 45 minutes' },
        { value: 9, text: '9 hours 00 minutes' },
        { value: 9.25, text: '9 hours 15 minutes' },
        { value: 9.50, text: '9 hours 30 minutes' },
        { value: 9.75, text: '9 hours 45 minutes' },
        { value: 10, text: '10 hours 00 minutes' },
        { value: 10.25, text: '10 hours 15 minutes' },
        { value: 10.50, text: '10 hours 30 minutes' },
        { value: 10.75, text: '10 hours 45 minutes' },
        { value: 11, text: '11 hours 00 minutes' },
        { value: 11.25, text: '11 hours 15 minutes' },
        { value: 11.50, text: '11 hours 30 minutes' },
        { value: 11.75, text: '11 hours 45 minutes' },
        { value: 12, text: '12 hours 00 minutes' },
        { value: 12.25, text: '12 hours 15 minutes' },
        { value: 12.50, text: '12 hours 30 minutes' },
        { value: 12.75, text: '12 hours 45 minutes' },
        { value: 13, text: '13 hours 00 minutes' },
        { value: 13.25, text: '13 hours 15 minutes' },
        { value: 13.50, text: '13 hours 30 minutes' },
        { value: 13.75, text: '13 hours 45 minutes' },
        { value: 14, text: '14 hours 00 minutes' },
    ]
}

export const notification_setting_types = () => {
    return [
        //{ notification_type: 'ChangeOrderReady', name: 'ChangeOrderReady', description: '', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ChangeOrderRemind', name: 'Change order reminder', description: 'Notify when a Change Order reaches the remind by date if not signed.', hasMailNotification: true, hasNotification: true },
        { notification_type: 'EmailReminder', name: 'Emails reminders', description: 'Notify emails reminders at the scheduled time', hasMailNotification: true, hasNotification: true },
        { notification_type: 'FollowedProjectsReportNotification', name: 'Followed projects report', description: 'Notify detailed email of followed projects', hasMailNotification: true, hasNotification: false },
        //{ notification_type: 'Invitation', name: 'Invitation', description: '', hasMailNotification: true, hasNotification: true },
        { notification_type: 'NoteCreated', name: 'Note created', description: 'Notify when a note is created', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'Notification', name: 'Notification', description: '', hasMailNotification: true, hasNotification: true },
        { notification_type: 'OpenServicesNotification', name: 'Open service notification', description: 'Notify when you have open services where the estimated bill date will expire soon', hasMailNotification: false, hasNotification: true },
        { notification_type: 'OpenServicesReportMessage', name: 'Open service report', description: 'Sends email with Open Services Report', hasMailNotification: true, hasNotification: false },
        { notification_type: 'ProjectAssignedToYou', name: 'Project assigned', description: 'Notify when you are assigned as a project manager to a project', hasMailNotification: true, hasNotification: false },
        { notification_type: 'ProjectManagerAssigned', name: 'Project Manager assigned', description: 'Nofify when a project manager is assigned', hasMailNotification: true, hasNotification: false },
        { notification_type: 'ProjectServiceAssigned', name: 'Project service assigned', description: 'Notify when project services are assigned to you', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ProjectServiceRemind', name: 'Project service remind', description: 'Notify when a project service reaches the LOC send date', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ProposalConvertedToProject', name: 'Proposal converted', description: 'Notify when a proposal is converted to project', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'ProposalMessage', name: 'ProposalMessage', description: '', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'ProposalMessageForCreator', name: 'ProposalMessageForCreator', description: '', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ProposalRemind', name: 'Proposal reminder', description: 'Notify when proposal is not signed yet', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ReminderCreated', name: 'Reminder created', description: 'Notify when a reminder is created', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ReminderSnoozedDatePassed', name: 'Reminders', description: 'Notify reminders at the scheduled time', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ReportMessage', name: 'Report message', description: 'Notify email report for the unprocessed envelopes', hasMailNotification: true, hasNotification: false },
        //{ notification_type: 'ResetPassword', name: 'ResetPassword', description: '', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'SendProjectReminder', name: 'SendProjectReminder', description: '', hasMailNotification: true, hasNotification: true },
        { notification_type: 'ServicesBilled', name: 'Services billed', description: 'Notify when a service is billed', hasMailNotification: true, hasNotification: false },
        //{ notification_type: 'SignableMessage', name: 'SignableMessage', description: '', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'SignableSignedByClient', name: 'SignableSignedByClient', description: '', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'SignableSignedToClient', name: 'SignableSignedToClient', description: '', hasMailNotification: true, hasNotification: true },
        //{ notification_type: 'SignableSignedToManager', name: 'SignableSignedToManager', description: '', hasMailNotification: true, hasNotification: true },
        { notification_type: 'TaskCreated', name: 'Task created', description: 'Notify when a task is created', hasMailNotification: true, hasNotification: true },
        { notification_type: 'TaskUpdated', name: 'Task updated', description: 'Notify when a task is updated', hasMailNotification: true, hasNotification: true },
        { notification_type: 'UserMonthlyGoal', name: 'User monthly goal', description: 'Notify email with monthly user goal', hasMailNotification: true, hasNotification: false },
    ]
}

export const rolePermissions = () => {
    return [
        { key: 'emails', name: 'Emails', description: 'User can see emails and send emails', enabled: false },
        { key: 'slack', name: 'Slack', description: 'User can see slack', enabled: false },
        { key: 'companies', name: 'Companies', description: 'Permissions of companies page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'projects', name: 'Projects', description: 'Permissions of projects page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'project_change_orders', name: 'Project Change Orders', description: 'User can see change orders tab', enabled: false },
        { key: 'tasks', name: 'Tasks', description: 'Permissions of tasks page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'proposals', name: 'Proposals', description: 'Permissions of proposals page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'reminders', name: 'Reminders', description: 'Permissions of reminders page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'time_manager', name: 'Time Manager', description: 'Permissions of time manager page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'services', name: 'Services', description: 'Permissions of services page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'milestones', name: 'Milestones', description: 'Permissions of milestones page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'activities', name: 'Activities', description: 'Permissions of activities page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'applications', name: 'Applications', description: 'Permissions of applications page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'notes', name: 'Notes', description: 'Permissions of notes page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'documents', name: 'Documents', description: 'Permissions of documents page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'time_logs', name: 'Time Logs', description: 'Permissions of time logs page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'job_costing', name: 'Job Costing', description: 'Permissions of job costing page', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'users', name: 'Users', description: 'Permissions of User', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'roles', name: 'Roles', description: 'Permissions of Roles', list: false, show: false, create: false, update: false, remove: false, isPage: false },
        { key: 'reports', name: 'Reports', only_main: true, description: 'Permissions of Reports', list: false, show: false, create: false, update: false, remove: false, isPage: false },

    ]
}
